import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeHtmlTags'
})
export class RemoveHtmlTagsPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (value) {
      const div = document.createElement("div");
      div.innerHTML = value;
      const text = div.textContent || div.innerText || "";
      return text;
    }
    return "";
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/remove-html-tags.pipe.ts